module.exports = __webpack_public_path__ + "static/media/project6.df61b95f.jpg";